import { getFirestore, query, collection, where, getDocs } from 'firebase/firestore'
import { useAppStore } from '@/stores/appdata'

const db = getFirestore()

// Le document appdata d'une application ne change pas pendant la session.
// On mémoïse sa résolution par application pour éviter une requête Firestore
// à chaque accès (le découpage par domaine multiplie le nombre d'accès).
const appdataIdCache = new Map()
const pendingLookups = new Map()

async function resolveAppdataId(appId) {
  let collectionRef = collection(db, "/appdata")
  let documentsQuery = query(collectionRef, where("application", "==", appId))
  let response = await getDocs(documentsQuery)

  // Comportement historique conservé : le dernier document `appdata` trouvé fait foi et
  // les éventuels doublons sont laissés en place. L'implémentation d'origine prévoyait de
  // les supprimer, mais la branche correspondante était inatteignable — le drapeau n'était
  // jamais repassé à false. Cette suppression n'a donc jamais eu lieu, et le client n'a
  // désormais plus le droit d'écrire.
  let appdata = null

  response.forEach(document => {
    appdata = document.data()
    appdata.id = document.id
  })

  return appdata ? appdata.id : null
}

let getCollectionPath = async (collectionName) => {
  const appStore = useAppStore()
  const appId = appStore.app.id

  if (!appdataIdCache.has(appId)) {
    if (!pendingLookups.has(appId)) {
      pendingLookups.set(appId, resolveAppdataId(appId).finally(() => pendingLookups.delete(appId)))
    }
    const appdataId = await pendingLookups.get(appId)
    if (appdataId) appdataIdCache.set(appId, appdataId)
    return `appdata/${appdataId}/${collectionName}`
  }

  return `appdata/${appdataIdCache.get(appId)}/${collectionName}`
}

export const clearCollectionPathCache = () => {
  appdataIdCache.clear()
  pendingLookups.clear()
}

export default getCollectionPath
